import React from "react";
import { ChipField, ReferenceArrayField, SingleFieldList, useTranslate } from "react-admin";
import { ModalDialog } from "../../../components/ModalDialog";

export const ReferenceArrayDialog = ({ record, ...rest }) => {
	const translate = useTranslate();

	return (
		<ModalDialog
			title={
				<span>
					{translate("osfc.dialogs.invoices.title")} [{record.date_from}, {record.date_to}
					]
				</span>
			}
			content={
				record[rest.source].length > 0 ?
					<ReferenceArrayField 
						{...rest} 
						record={record} 
						reference="orders" 
						target="selected_ids"
						style={{ padding: "20px"}}
					>
						<SingleFieldList linkType="show" style={{ display: "block" }}>
							<ChipField source="id" size="small" />
						</SingleFieldList>
					</ReferenceArrayField>
				: null
			}
		/>
	);
};
